/**
 * Created with IntelliJ IDEA.
 * User: liors
 * Date: 7/23/13
 * Time: 3:52 PM
 * To change this template use File | Settings | File Templates.
 */
define(function (require) {
    "use strict";

    var _ = require("underscore");
    var RevisionedModel = require("models/RevisionedModel");

    var QuestionModel = RevisionedModel.extend({
        name: "QuestionModel",
        defaults: {
          "question": "",
          "logicID": -1,
          "displayed": true,
          "required": false,
          "UDEScope": "",
          "UDEType": "",
          "globalName": "",
          "encrypted": false,
          "isAutoSubmitQuestion": false,
          "answersList": null,
          "routingAnswersList": null,
          "isSpecialQuestion": false,
          "type":"",
          "readOnly": false,
          "mandatory": false
        },

        isRendered: function () {
            return this.getDisplay();
        },
        shouldDisplay: function () {
            return (this.getUDEType() === UDE_TYPES.TEXT_AREA ||
                this.getUDEType() === UDE_TYPES.TEXT_FIELD ||
                this.getUDEType() === UDE_TYPES.NUMERIC_FIELD ||
                this.getUDEType() === UDE_TYPES.NAME_FIELD ||
                this.getUDEType() === UDE_TYPES.FIRST_NAME_FIELD ||
                this.getUDEType() === UDE_TYPES.LAST_NAME_FIELD ||
                this.getUDEType() === UDE_TYPES.EMAIL_FIELD ||
                this.getUDEType() === UDE_TYPES.MESSAGE_FIELD) ? "none" : "block";
        },
        isDropDown: function () {
            return (this.getUDEType() === UDE_TYPES.DROPDOWN_BOX && this.getType() !== UDE_TYPES.ROUTING_QUESTION) && !this.isCSAT();
        },
        dropDown: function () {
            return (this.getUDEType() === UDE_TYPES.DROPDOWN_BOX && this.getType() !== UDE_TYPES.ROUTING_QUESTION) ? RETURN_STRINGS.SELECTED : "";
        },
        isCSAT: function () {
            return this.getType() === KEYS.CSAT;
        },
        csatField: function () {
            return this.isCSAT() ? RETURN_STRINGS.SELECTED : "";
        },
        isName: function () {
            return this.getType() === KEYS.NAME;
        },
        nameField: function () {
            return this.isName() ? RETURN_STRINGS.SELECTED : "";
        },
        isFirstName: function () {
            return this.getType() === KEYS.FISRT_NAME;
        },
        firstNameField: function () {
            return this.isFirstName() ? RETURN_STRINGS.SELECTED : "";
        },
        isLastName: function () {
            return this.getType() === KEYS.LAST_NAME;
        },
        lastNameField: function () {
            return this.isLastName() ? RETURN_STRINGS.SELECTED : "";
        },
        isEmail: function () {
            return this.getType() === KEYS.EMAIL;
        },
        emailField: function () {
            return this.isEmail() ? RETURN_STRINGS.SELECTED : "";
        },
        isMessage: function () {
            return this.getType() === KEYS.MESSAGE;
        },
        messageField: function () {
            return this.isMessage() ? RETURN_STRINGS.SELECTED : "";
        },
        isRadioButton : function () {
            return (this.getUDEType() === UDE_TYPES.RADIO_BUTTON || this.getUDEType() === UDE_TYPES.RADIO_BUTTON_SIDE_BY_SIDE) && !this.isCSAT();
        },
        radioButton: function () {
            return (this.getUDEType() === UDE_TYPES.RADIO_BUTTON || this.getUDEType() === UDE_TYPES.RADIO_BUTTON_SIDE_BY_SIDE) && !this.isCSAT() ? RETURN_STRINGS.SELECTED : "";
        },
        isCheckBox: function () {
            return this.getUDEType() === UDE_TYPES.CHECKBOX;
        },
        checkBox : function () {
            return this.getUDEType() === UDE_TYPES.CHECKBOX ? RETURN_STRINGS.SELECTED : "";
        },
        isTextField : function () {
            return this.getUDEType() === UDE_TYPES.TEXT_FIELD;
        },
        textField: function () {
            return (this.getUDEType() === UDE_TYPES.TEXT_FIELD && !this.isName() && !this.isFirstName() && !this.isLastName() && !this.isEmail()) ? RETURN_STRINGS.SELECTED : "";
        },
        isTextArea: function () {
            return this.getUDEType() === UDE_TYPES.TEXT_AREA;
        },
        textArea: function () {
            return (this.getUDEType() === UDE_TYPES.TEXT_AREA && !this.isMessage()) ? RETURN_STRINGS.SELECTED : "";
        },
        isNumericField : function () {
            return this.getUDEType() === UDE_TYPES.NUMERIC_FIELD;
        },
        numericField: function () {
            return this.getUDEType() === UDE_TYPES.NUMERIC_FIELD ? RETURN_STRINGS.SELECTED : "";
        },
        requiredQuestion: function () {
            return this.isRequired() ? RETURN_STRINGS.CHECKED : "";
        },
        requiredQuestionAsterix: function () {
            return this.isRequired() ? RETURN_STRINGS.ASTERIX : "";
        },
        /* Survey Based Routing addition */
        surveyBasedRouting: function () {
            return this.getType() === QUESTION_TYPES.ROUTING ? RETURN_STRINGS.SELECTED : "";
        },
        isSurveyBasedRouting: function () {
            return this.get(KEYS.TYPE) === QUESTION_TYPES.ROUTING;
        },
        isReadOnly: function () {
            return this.get(KEYS.READ_ONLY);
        },

        setReadOnly: function(isReadOnly){
            this.set(KEYS.READ_ONLY, isReadOnly);
        },

        uniqueAnswer:function (answerText) {
            // validate if answer exists
            var exists = this.answerTextExists(answerText);
            if (exists) {
                return "LECampaigns.engagementWindow.answer.text.validation.error";
            }
        },

        answerTextExists:function (answerText) {
            var allowedWithSameName = 1;
            var resultCollection = [];
            if(this.attributes.routingAnswersList) {
                resultCollection = this.attributes.routingAnswersList.routingAnswer.filter(function(eachAnswer){return(eachAnswer.displayText === answerText);});
            } else if(this.attributes.answersList) {
                resultCollection = this.attributes.answersList.answer.filter(function(eachAnswerText){return(eachAnswerText === answerText);});
            }
            return (resultCollection.length > allowedWithSameName);
        },

        /* private getter setter */
        _setValue: function (key, value) {
            this.set(key, value);
            this.setValidations();
        },
        validation: {

        },
        setValidations: function () {
            // this method sets the validations from the "engagementWindowSurveyQuestionValidationConfig.json" for this model
            this.validation = {};
            var that = this;

            _.each(validationConfig.validation, function (val, key) {
                if (_.has(that.attributes,key)) {
                    that.validation[key] = val;
                }
            });

            //this.setValidationsForDisplayInstances();
            this.setValidationsForArrays();
        },
        setValidationsForArrays: function () {
            // this method sets the array validations from "engagementWindowSurveyQuestionValidationConfig.json" for this model
            var that = this;
            var flatAttr;

            _.each(validationConfig.validationForArrays, function (outerVal, outerKey) {
                // within "validationForArrays", "outerVal" is each value (the array of values), and "outerKey" is each key (names)
                _.each(outerVal, function (validationsArray, key) {
                    // within "outerVal", "validationsArray" is the value (the array of validations) and "key" is the key ("{index}")

                    // in the following lines (until the end of the for loop) we go through the attributes in the question model
                    // and navigate to the appropriate attribute. So, if the json has "answersList.answer" we will set "attributes"
                    // as questionModel.attributes.answersList.answer
                    var splitAttr = outerKey.split(".");
                    var attributes = that.attributes;
                    for (var attributeIndex = 0; attributeIndex < splitAttr.length; attributeIndex++) {
                        if (_.has(attributes, splitAttr[attributeIndex])) {
                            attributes = attributes[splitAttr[attributeIndex]];
                        }
                    }
                    // here we go over the members of "validationsArray" (an array of validation settings) and look for our "custom"
                    // setting so we can replace with the selected function
                    if (validationsArray != null && validationsArray.length > 0){
                        for (var validationIndex = 0; validationIndex < validationsArray.length; validationIndex++ ){
                            if (validationsArray[validationIndex].hasOwnProperty("custom")) {
                                var newValidation = { fn: that[validationsArray[validationIndex].custom]};
                                validationsArray[validationIndex] = newValidation;
                            }
                        }
                    }

                    var array = attributes;
                    // now that we have the array in the model (specified in the json) we can go over each item
                    // and create a validation for it, based on the json according to its index in the array
                    if (array != null && array.length > 0) {
                        for (var i = 0; i < array.length; i++) {
                            flatAttr = outerKey + "." + key.replace("{index}", i);
                            that.validation[flatAttr] = validationsArray;
                        }
                    }
                });
            });
        },

        /* public */
        getQuestion: function () {
            return this.get(KEYS.QUESTION);
        },
        setQuestion: function (question) {
            return this._setValue(KEYS.QUESTION, question);
        },
        getLogicID:function(){
            return this.get(KEYS.ID);
        },
        setId: function (id) {
            this._setValue(KEYS.ID, id);
        },
        setRequired: function(required) {
            this._setValue(KEYS.REQUIRED, required);
        },
        isRequired: function(){
            return this.get(KEYS.REQUIRED);
        },
        setMandatory: function(mandatory) {
            this._setValue(KEYS.MANDATORY, !!mandatory);
        },
        isMandatory: function() {
            return this.get(KEYS.MANDATORY);
        },
        setAnswers: function(answers) {
            if(answers && answers.length > 0) {
                if(this.isCSAT()){
                    this.csatAnswers= answers;

                    //parse answers back to legacy format used by the backend
                    var parsedAnswers= _.map(answers, function (answer) {
                        return answer.value;
                    });
                    this._setValue(KEYS.ANSWERS, parsedAnswers);
                }else if (this.isSurveyBasedRouting()){
                    this._setValue(KEYS.ROUTINGANSWERS, answers);
                } else {
                    this._setValue(KEYS.ANSWERS, answers);
                }
            }
        },
        getAnswers: function() {
            if (this.isCSAT()) {
                return this.csatAnswers;
            } else if(this.isSurveyBasedRouting()) {
                return this.get(KEYS.ROUTINGANSWERS);
            } else {
                return this.get(KEYS.ANSWERS);
            }
        },
        getRoutingAnswers: function(){
            return this.get(KEYS.ROUTINGANSWERS);
        },
        getAnswerListAnswers: function(){
            return this.get(KEYS.ANSWERS);
        },
        setAnswerListAnswers: function(answers, options){
            this.set(KEYS.ANSWERS, answers, options);
        },
        setRoutingAnswersList: function(answers, options){
            this.set(KEYS.ROUTINGANSWERS, answers, options);
        },
        addAnswer: function(answer) {
            var key = "";
            if (this.isSurveyBasedRouting()) {
                if(!this.get(KEYS.ROUTINGANSWERS)) {
                    this.set(KEYS.ROUTINGANSWERS, []);
                }
                key = KEYS.ROUTINGANSWERS + "." + this.get(KEYS.ROUTINGANSWERS).length;
                this.set(key, { "displayText": answer, "hintText": "", "skillName": "", "skillId": ""});
            } else {
                if(!this.get(KEYS.ANSWERS)) {
                    this.answersList.answer = [];
                }
                key = KEYS.ANSWERS + "." + this.get(KEYS.ANSWERS).length;
                this.set(key, answer);
            }
        },
        deleteAnswer: function(answerText) {
            // deletes only one instance of the given answer
            var newArr = [];
            var deleted = false;
            if (this.isSurveyBasedRouting()) {
                var rAnswerList = this.get(KEYS.ROUTINGANSWERS);
                newArr = _.filter(rAnswerList, function(answer){
                    if (answer.displayText == answerText) {
                        if (!deleted) {
                            deleted = true;
                            return false; // filter out element
                        }
                    }
                    return true; // keep element
                });
                this.set(KEYS.ROUTINGANSWERS, newArr);
            } else {
                var answerList = this.get(KEYS.ANSWERS);
                for (var answer in answerList) {
                    if ((answerList[answer] !== answerText) || deleted) {
                        newArr.push(answerList[answer]);
                    } else {
                        deleted = true;
                    }
                }
                this.set(KEYS.ANSWERS, newArr);
            }
        },

        reorderRoutingAnswer: function(reArrangedArray) {
            this.set(KEYS.ROUTINGANSWERS, reArrangedArray);
        },

        reorderAnswer: function(reArrangedArray) {
            this.set(KEYS.ANSWERS, reArrangedArray);
        },
        getDisplay:function(){
            return this.get(KEYS.DISPLAYED);
        },
        setDisplay :function(displayed){
            this._setValue(KEYS.DISPLAYED, displayed);
        },

        setIsSpecialQuestion :function(value){
            this._setValue(KEYS.ISSPECIALQUESTION, value);
        },

        getIsSpecialQuestion :function(){
            return this.get(KEYS.ISSPECIALQUESTION);
        },

        setGlobalName:function(value){
            this._setValue(KEYS.GLOBALNAME, value);
        },
        getType:function(){
            return this.get(KEYS.TYPE);
        },
        setType:function(value){
            this._setValue(KEYS.TYPE, value);
        },
        getUDEType:function(){
            return this.get(KEYS.UDETYPE);
        },
        setUDEType:function(value){
            this._setValue(KEYS.UDETYPE, value);
        },
        setUDEScope: function(value){
            this.set(KEYS.UDESCOPE, value);
        },
        setEditMode: function(isEditMode){
            this.set(KEYS.EDIT_MODE, isEditMode);
        },
        getEditMode: function(){
            return this.get(KEYS.EDIT_MODE);
        }
    });

    var KEYS = {
        ID: "logicID",
        QUESTION: "question",
        UDETYPE: "UDEType",
        UDESCOPE: "UDEScope",
        ANSWERS: "answersList.answer",
        ROUTINGANSWERS: "routingAnswersList.routingAnswer",
        REQUIRED: "required",
        DISPLAYED: "displayed",
        ISSPECIALQUESTION: "isSpecialQuestion",
        GLOBALNAME:"globalName",
        TYPE:"type",
        CSAT:"chat_customer_satisfaction_1",
        ROUTINGANSWERSLIST: "routingAnswersList",
        READ_ONLY: "readOnly",
        EDIT_MODE: "editmode",
        NAME: "identifier",
        FISRT_NAME: "firstname",
        LAST_NAME: "lastname",
        EMAIL: "email",
        MESSAGE: "message",
        MANDATORY: "mandatory"
    };

    var UDE_TYPES = {
        NAME_FIELD: "Name Field",
        FIRST_NAME_FIELD: "First Name Field",
        LAST_NAME_FIELD: "Last Name Field",
        EMAIL_FIELD: "Email Field",
        MESSAGE_FIELD: "Message Field",
        TEXT_AREA: "Text Area",
        TEXT_FIELD: "Text Field",
        NUMERIC_FIELD: "Numeric Field",
        DROPDOWN_BOX: "Dropdown Box",
        ROUTING_QUESTION: "routing_question",
        RADIO_BUTTON: "Radio Button",
        RADIO_BUTTON_SIDE_BY_SIDE: "Radio Button (side by side)",
        CHECKBOX: "Checkbox"
    };

    var UDE_SCOPES = {
        SESSION: "Session"
    };

    var RETURN_STRINGS = {
        SELECTED: "selected='selected'",
        CHECKED: "checked='checked'",
        ASTERIX: "*"
    };

    var QUESTION_TYPES = {
        DEFAULT: "",
        ROUTING: "routing_question",
        CSAT: "chat_customer_satisfaction_1",
        NAME: "identifier",
        FISRT_NAME: "firstname",
        LAST_NAME: "lastname",
        EMAIL: "email",
        MESSAGE: "message"
    };

    var validationConfig = require("campaigns-assets/config/engagementWindowSurveyQuestionValidationConfig.json");

    QuestionModel.KEYS = KEYS;
    QuestionModel.UDE_TYPES = UDE_TYPES;
    QuestionModel.UDE_SCOPES = UDE_SCOPES;
    QuestionModel.QUESTION_TYPES = QUESTION_TYPES;
    return QuestionModel;
});
